<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <jd-tip style="margin-bottom: 10px"
          >云短信CRM ：订购到期时间
          {{ jdCrm.endTime }}（店铺需要搭配云短信CRM使用）。</jd-tip
        >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <!-- 基本信息 -->
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :isNeedCusType="true"
            :cusType.sync="ruleDTO.cusType"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :activityId="81"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="活动设置"></jd-title>
          <div class="mt20">
            <el-form-item label="参与方式：" required>
              <el-radio-group
                v-model="ruleDTO.participateType"
                :disabled="activityData.isStart"
                @change="changeJoinType"
              >
                <el-radio :label="0"
                  >用户报名参与（消费者需要手动报名，未报名不统计）</el-radio
                >
                <el-radio :label="1"
                  >免报名参与（消费者无需报名活动，开榜前进入活动时自动判断用户身份，符合条件则自动报名）</el-radio
                >
              </el-radio-group>
              <div class="rule_box" v-if="ruleDTO.participateType == 0">
                <el-form-item label-width="120px" label="报名时间范围:" required
                  >用户在
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleDTO.participateTimeStart"
                      type="datetime"
                      placeholder="开始日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      default-time="00:00:00"
                      style="width: 185px; font-size: 12px"
                      class="time1"
                      :picker-options="joinTimePickerOptionsValue"
                      :disabled="isDisabeldWin"
                      :clearable="false"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleDTO.participateTimeEnd"
                      type="datetime"
                      placeholder="结束日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      default-time="23:59:59"
                      style="width: 200px; font-size: 12px"
                      class="time2"
                      :picker-options="joinTimePickerOptionsValueEnd"
                      :disabled="isDisabeldWin"
                      :clearable="false"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      v-if="!activityData.isStart"
                      @click="
                        ruleDTO.participateTimeStart = '';
                        ruleDTO.participateTimeEnd = '';
                      "
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                  期间内报名
                  <jd-button
                    @click="syncJoinTime"
                    type="blueText"
                    :disabled="isDisabeldWin"
                    >同步开榜时间</jd-button
                  >
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="任务设置：" required>
              <taskComponent
                :taskList.sync="taskDataList"
                :taskOrders.sync="taskOrderList"
                :copySteList.sync="taskLevelList"
                :mainText="mainText"
                :otherUnit="otherUnit"
                :unit="unit"
                :extraText="extraText"
                :isShowCustom="isShowCustom"
                :isTrueEdit="true"
                :isShowUnit="isShowUnit"
                :activityData="activityData"
                :activityStartTime="activityStartTime"
                :activityEndTime="activityEndTime"
                :hasSelectGoods="hasSelectGoods"
                :openingTime="ruleDTO.rankPrizeTime"
              />
            </el-form-item>
          </div>
          <!-- 奖品设置 -->
          <jd-title label="奖品设置"></jd-title>
          <div class="mt20">
            <el-form-item label="开榜时间:" required>
              <div class="flex-r">
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="ruleDTO.rankPrizeTime"
                    type="datetime"
                    placeholder="选择日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 200px; font-size: 12px"
                    default-time="00:00:00"
                    :clearable="false"
                    :picker-options="rankTimePicker"
                    :disabled="isDisabeldWin"
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearShowRankTime()"
                  ></i>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  />
                </div>
                <div class="ml8">
                  即冲榜截止时间，截榜后才可按排名领取奖品，且不再更新榜单
                </div>
              </div>
            </el-form-item>
            <el-form-item label="领奖配置：" required>
              <el-radio-group
                v-model="ruleDTO.prizeConfig"
                :disabled="isDisabeldWin"
              >
                <el-radio :label="0"
                  >到达开榜时间后，系统自动按排名触发领奖（有实物奖品时建议开启预留地址）</el-radio
                >
                <el-radio :label="1"
                  >到达开榜时间后，C端用户需进入活动手动领取奖品</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否开启预留地址:">
              <el-switch
                v-model="ruleDTO.isReservedAddress"
                :disabled="isDisabeldWin"
              >
              </el-switch>
              <span class="openTip"
                >开启后，用户报名成功时将引导用户预留收货地址。不开启则在开榜后用户领取奖品时再引导填写地址</span
              >
            </el-form-item>
            <el-form-item label="奖品设置：">
              <div class="mb10">
                开榜后发放奖励，整个活动期内每人<span class="showTip"
                  >只可领取1次及其中1个奖品</span
                >
              </div>
              <newPrizeTable
                :prizeList.sync="prizeSetting"
                :isIndex="isIndex"
                :isDisabled="activityData.isStart"
                :isDisabledTotal="isDisabledTotal"
                :tableInfo="tableInfo"
                :valueRow="valueRow"
                :isShowUpLoadBtn="true"
                :actType="81"
                :isShowMoveBtn="isShowMoveBtn"
                :actEndTime="ruleForm.endTime"
              >
                <!-- 作用域插槽实现额外字段的输入 -->
                <template #rankTypeName="{ scopeRow, scopeIndex }">
                  <div class="flex-r">
                    <el-select
                      v-model="scopeRow.scoreRankWinConditionDTO.winType"
                      placeholder="请选择"
                      class="w120"
                      :disabled="activityData.isStart"
                      @change="handleWinTypeChange(scopeRow, scopeIndex)"
                    >
                      <el-option label="排名区间" :value="0" />
                      <el-option label="指定名次" :value="1" />
                    </el-select>
                    <div
                      class="flex-r ml8"
                      v-if="scopeRow.scoreRankWinConditionDTO.winType === 0"
                    >
                      <el-input
                        v-model="scopeRow.scoreRankWinConditionDTO.rankStart"
                        placeholder="请输入"
                        class="w80"
                        :disabled="activityData.isStart"
                        @input="
                          (val) => filterRankNumber(val, scopeRow, 'rankStart')
                        "
                        @change="rankedChange(scopeRow, scopeIndex)"
                      />
                      <span class="mlr8">~</span>
                      <el-input
                        v-model="scopeRow.scoreRankWinConditionDTO.rankEnd"
                        placeholder="请输入"
                        class="w80"
                        :disabled="activityData.isStart"
                        @input="
                          (val) => filterRankNumber(val, scopeRow, 'rankEnd')
                        "
                        @change="rankedChange(scopeRow, scopeIndex)"
                      />
                    </div>
                    <div class="ml8" v-else>
                      <el-input
                        v-model="scopeRow.scoreRankWinConditionDTO.rankNum"
                        placeholder="请输入"
                        :disabled="activityData.isStart"
                        @input="
                          (val) => filterRankNumber(val, scopeRow, 'rankNum')
                        "
                        @change="rankedChange(scopeRow, scopeIndex)"
                      />
                    </div>
                  </div>
                </template>
              </newPrizeTable>
              <jd-button
                class="mt16"
                type="blue"
                :disabled="
                  activityData.isStart || prizeSetting.length >= limitNum
                "
                @click="addPrizeSetting"
                >+增加排名（{{ prizeSetting.length }}/{{ limitNum }}</jd-button
              >
            </el-form-item>
          </div>
          <!-- 活动页设置 -->
          <activityPageSettings
            isShowShopName
            isShowMoreSet
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            :templateId="templateId"
            :isShowDesignNumber="false"
            previewKey="url"
            templatekey="imageUrl"
            :widthNumber="750"
            :heightNumber="1808"
            :isCustomPreview="true"
            :downloadTemplateUrl="templateUrl"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/collect-point-rank-design.png"
            themeTitle="主题"
            :defaultRgb="currrentRgb"
            v-model="customerPaperwork"
            @selectTemplate="selectTemplate"
          >
            <template #customPreview>
              <collectPointRankDialog
                :ruleForm="ruleForm"
                :ruleDTO="ruleDTO"
                :backgroundImage="backgroundImage"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :productList="prizeSetting"
              />
            </template>
            <template #otherSet>
              <!-- 自定义活动页设置 -->
              <el-form-item label="选中导航设置:">
                <div class="upload-box">
                  <btnSet
                    :customerData="customerPaperwork"
                    bgKey="url2"
                    colorKey="selectColor"
                    :pw="176"
                    :ph="70"
                    labelText="选中导航背景图"
                    :backgroundOpacity="backgroundOpacity"
                    :resetColor="currrentRgb2"
                  />
                </div>
              </el-form-item>
              <el-form-item label="未选中导航设置:">
                <div class="upload-box">
                  <btnSet
                    :isBgUrl="false"
                    :customerData="customerPaperwork"
                    bgKey="unSelectBgColor"
                    colorKey="unSelectColor"
                    :backgroundOpacity="backgroundOpacity"
                    :resetBgColor="currrentRgb3"
                    :resetColor="currrentRgb4"
                    labelWidth="110px"
                  >
                    <el-form-item label="背景不透明度：" label-width="110px">
                      <div class="flex-r">
                        <el-slider
                          class="w200"
                          v-model="customerPaperwork.navOpacity"
                          :step="1"
                          :min="0"
                          :max="100"
                        ></el-slider>
                        <el-input
                          @input="
                            customerPaperwork.navOpacity = +getNumberData(
                              1,
                              $event,
                              0,
                              0,
                              100
                            )
                          "
                          v-model="customerPaperwork.navOpacity"
                          class="w60 ml16"
                        ></el-input
                        ><span class="ml8">%</span>
                      </div>
                    </el-form-item>
                  </btnSet>
                </div>
              </el-form-item>
              <el-form-item label="按钮设置:">
                <div class="upload-box">
                  <btnSet
                    :customerData="customerPaperwork"
                    bgKey="url3"
                    colorKey="btnColor"
                    :pw="580"
                    :ph="98"
                    labelText="按钮背景图"
                    :backgroundOpacity="backgroundOpacity"
                    :resetColor="currrentRgb5"
                  />
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
            :activityData="activityData"
            :valueRow="valueRow"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick
          >保存设置</jd-button
        >
      </template>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  saveOrUpdateScoreRank,
  getScoreRankDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import collectPointRankDialog from "./components/newActPreviews/collect-point-rank-dialog.vue";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import taskComponent from "./components/_components/taskComponent.vue";
import {
  useInputTaskData,
  useOutputTaskData,
  useCondition,
} from "./components/commDataHook/useTaskData.js";
import {
  useOutputBasicInformation,
  useInputBasicInformation,
  useUpdateBasicInformation,
  useValidateBasicInformation,
  useValidatePrizeInformation,
  useValidateActEndInfomation,
} from "./components/commDataHook/useBasicInformation.js";
import { useJdCrm } from "./components/commDataHook/useCommReq.js";
import btnSet from "./components/commCustomizationSet/btnSet.vue";
export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    collectPointRankDialog,
    taskComponent,
    newPrizeTable,
    btnSet,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jdCrm: {
        endTime: "",
      },
      isDisabledTotal: true,
      limitNum: 20,
      isIndex: false,
      isShowCustom: true,
      mainText: "分数",
      otherUnit: "分",
      unit: "",
      extraText:
        "*添加任务后可在任务列表输入自定义任务名称和任务描述，不输入则使用默认名称和描述",
      hasSelectGoods: [],
      isShowUnit: false,
      taskLevelList: [],
      isShowMoveBtn: true,
      prizeSetting: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          scoreRankWinConditionDTO: {
            winType: 0, //排名类型
            rankStart: "", //排名开始
            rankEnd: "", //排名结束
            rankNum: "", //指定名次
          },
        },
      ], //奖品设置
      taskDataList: [], //任务列表
      taskOrderList: [],
      isLimit: true,
      tableInfo: [
        {
          label: "排名设置",
          prop: "scoreRankWinConditionDTO",
          slot: "rankTypeSlot",
          slotName: "rankTypeName",
          width: 320,
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          width: 160,
        },
        {
          label: "值",
          prop: "price",
          width: 130,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          width: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slotHead: "totalAmountHeader",
          slot: "totalAmountSlot",
          width: 180,
        },
        {
          label: "奖品图片",
          prop: "logo",
          slot: "logoSlot",
          width: 120,
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 300,
        },
      ],
      isKeyActivity: 0,
      placementPosition: [],
      isForceRemind: 0,
      templateUrl:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/%E9%9B%86%E5%88%86%E6%89%93%E6%A6%9C.psd",
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      currrentRgb4: "",
      currrentRgb5: "",
      customerPaperwork: {
        title: "集分冲榜",
        desc: "做任务集分数，冲榜解锁专属福利",
        titleColor: "#ffffff", //主题字体颜色
        url2: "", //选中导航背景图
        url3: "", //按钮背景图
        selectColor: "#ffffff", //选中导航字体颜色
        unSelectBgColor: "#ffffff", //未选中导航背景颜色
        unSelectColor: "#000000", //未选中导航字体颜色
        navOpacity: 100, //导航背景不透明度
        btnColor: "#ffffff", //按钮字体颜色
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
      },
      sharePic: "https://cdn-image.yucrm.cn/hd/images/collect-point-rank.png",
      ruleDTO: {
        participateType: 1,
        participateTimeStart: "",
        participateTimeEnd: "",
        rankPrizeTime: "",
        prizeConfig: 0,
        isReservedAddress: false,
        customerPaperwork: "",
        cusTemplateJSON: "",
        cusType: 0, //新老客类型
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "https://cdn-image.yucrm.cn/hd/images/collect-point-rank.png",
        openCardStartTime: "",
        goShopSetting: 0, //进店设置
        goShopAppId: "", //小程序appId
        goShopUrl: "", //小程序页面路径
      },
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      pickerOption: {
        disabledDate: (time) => {
          //  在活动开始-结束时间范围内
          return (
            time.getTime() < new Date(this.activityStartTime).getTime() ||
            time.getTime() >
              new Date(this.activityEndTime).getTime() - 24 * 60 * 60 * 1000
          );
        },
      },
      joinTimePickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            (this.ruleForm.startTime
              ? time.getTime() <
                new Date(this.ruleForm.startTime).valueOf() - 8.64e7
              : false) ||
            (this.ruleForm.endTime
              ? time.getTime() > new Date(this.ruleForm.endTime).valueOf()
              : false) ||
            (this.ruleDTO.participateTimeEnd
              ? time.getTime() >
                new Date(this.ruleDTO.participateTimeEnd).valueOf()
              : false) ||
            (this.ruleDTO.rankPrizeTime
              ? time.getTime() > new Date(this.ruleDTO.rankPrizeTime).valueOf()
              : false)
          );
        },
      },
      joinTimePickerOptionsValueEnd: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            (this.ruleForm.endTime
              ? time.getTime() >
                new Date(this.ruleForm.endTime).valueOf() - 8.64e7
              : false) ||
            (this.ruleDTO.participateTimeStart
              ? time.getTime() <
                new Date(this.ruleDTO.participateTimeStart).valueOf() - 8.64e7
              : false) ||
            (this.ruleForm.startTime
              ? time.getTime() <
                new Date(this.ruleForm.startTime).valueOf() - 8.64e7
              : false) ||
            (this.ruleDTO.rankPrizeTime
              ? time.getTime() > new Date(this.ruleDTO.rankPrizeTime).valueOf()
              : false)
          );
        },
      },
      //开榜时间限制
      rankTimePicker: {
        disabledDate: (time) => {
          let start = this.activityStartTime
            ? new Date(this.activityStartTime).getTime() - 8.64e7
            : 0;
          // 结束时间限制为活动结束时间前24小时
          let end = this.activityEndTime
            ? new Date(this.activityEndTime).getTime() - 8.64e7
            : Infinity;
          let current = time.getTime();
          if (current > start && current <= end) {
            return false;
          } else {
            return true;
          }
        },
      },
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    backgroundImage() {
      return this.ruleDTO.cusTemplateJSON
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.templateObj.url;
    },
    // 开榜前是否禁用
    isDisabeldWin() {
      // 当前时间
      let currentTime = new Date().getTime();
      let flag = false;
      if (
        this.ruleDTO.rankPrizeTime &&
        this.compareTime(this.ruleDTO.rankPrizeTime) > currentTime
      ) {
        flag = false;
      } else {
        flag = this.activityData.isStart;
      }
      return flag;
    },
  },
  watch: {},
  created() {
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    useJdCrm(this);
    this.buriedPoint(1, "集分冲榜", "互动管理", "互动活动");
  },

  methods: {
    handleWinTypeChange(row, index) {
      row.scoreRankWinConditionDTO.rankStart = "";
      row.scoreRankWinConditionDTO.rankEnd = "";
      row.scoreRankWinConditionDTO.rankNum = "";
    },
    syncJoinTime() {
      if (!this.ruleForm.startTime) {
        return this.$message.warning("请先选择活动开始时间");
      }
      if (!this.ruleDTO.rankPrizeTime) {
        return this.$message.warning("请先选择开榜时间");
      }
      this.ruleDTO.participateTimeStart = this.ruleForm.startTime;
      this.ruleDTO.participateTimeEnd = this.ruleDTO.rankPrizeTime;
    },
    compareTime(time) {
      return new Date(time).getTime();
    },
    clearShowRankTime() {
      this.ruleDTO.rankPrizeTime = "";
    },
    changeJoinType() {
      this.ruleDTO.participateTimeStart = "";
      this.ruleDTO.participateTimeEnd = "";
    },
    // 增加奖品设置
    addPrizeSetting() {
      if (this.prizeSetting.length >= this.limitNum) {
        return this.$message.warning(`最多只能添加${this.limitNum}个奖品`);
      }
      this.prizeSetting.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        singleAmount: "",
        scoreRankWinConditionDTO: {
          winType: 0, //排名类型
          rankStart: "", //排名开始
          rankEnd: "", //排名结束
          rankNum: "", //指定名次
        },
      });
    },
    // 输入时只做数字过滤，不做大小比较，避免输入过程中被清空
    filterRankNumber(val, row, field) {
      let filtered = val.replace(/^0|[^\d]/g, "");
      let num = Number(filtered);
      if (num < 1) {
        filtered = "";
      }
      row.scoreRankWinConditionDTO[field] = filtered;
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    rankedChange(item, index) {
      const condition = item.scoreRankWinConditionDTO;
      const rankStart = Number(condition.rankStart);
      const rankEnd = Number(condition.rankEnd);
      const rankNum = Number(condition.rankNum);

      let isValid = true;

      if (condition.winType === 0) {
        if (rankEnd && rankStart) {
          if (rankEnd <= rankStart) {
            this.$message.warning("区间结束值必须大于开始值");
            condition.rankEnd = "";
            isValid = false;
          }
        }
      }

      if (isValid && index > 0) {
        const prevCondition =
          this.prizeSetting[index - 1].scoreRankWinConditionDTO;
        const prevEnd =
          prevCondition.winType === 0
            ? Number(prevCondition.rankEnd)
            : Number(prevCondition.rankNum);

        if (prevEnd) {
          const currentStart = condition.winType === 0 ? rankStart : rankNum;
          if (currentStart && currentStart <= prevEnd) {
            this.$message.warning(
              `当前${
                condition.winType === 0 ? "区间开始值" : "指定名次"
              }必须大于前${
                prevCondition.winType === 0 ? "区间结束值" : "指定名次"
              }`
            );
            if (condition.winType === 0) {
              condition.rankStart = "";
            } else {
              condition.rankNum = "";
            }
            isValid = false;
          }
        }
      }

      if (isValid && index < this.prizeSetting.length - 1) {
        const nextCondition =
          this.prizeSetting[index + 1].scoreRankWinConditionDTO;
        const currentEnd = condition.winType === 0 ? rankEnd : rankNum;

        if (currentEnd) {
          const nextStart =
            nextCondition.winType === 0
              ? Number(nextCondition.rankStart)
              : Number(nextCondition.rankNum);
          if (nextStart && nextStart <= currentEnd) {
            this.$message.warning(
              `后${
                nextCondition.winType === 0 ? "区间开始值" : "指定名次"
              }必须大于当前${
                condition.winType === 0 ? "区间结束值" : "指定名次"
              }`
            );
            if (nextCondition.winType === 0) {
              nextCondition.rankStart = "";
            } else {
              nextCondition.rankNum = "";
            }
            this.prizeSetting[index + 1].totalAmount = null;
          }
        }
      }

      this.prizeSetting.forEach((prize, idx) => {
        const prizeCondition = prize.scoreRankWinConditionDTO;
        const prizeStart = Number(prizeCondition.rankStart);
        const prizeEnd = Number(prizeCondition.rankEnd);
        const prizeNum = Number(prizeCondition.rankNum);

        if (prizeCondition.winType === 0) {
          if (prizeStart && prizeEnd) {
            let total = prizeEnd - prizeStart + 1;
            prize.totalAmount = total > 0 ? total : null;
          } else if (prizeStart || prizeEnd) {
            prize.totalAmount = null;
          }
        } else if (prizeCondition.winType === 1) {
          prize.totalAmount = prizeNum > 0 ? 1 : null;
        }
      });
    },
    onShopSetChange(value) {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },
    resetRgb(row, configJson) {
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
      this.currrentRgb4 = configJson.rgb4;
      this.currrentRgb5 = configJson.rgb5;
    },
    initCustomizeData(row) {
      const configJson = row.configJson ? JSON.parse(row.configJson) : {};
      this.customerPaperwork.titleColor = row.rgb || "#ffffff";
      this.customerPaperwork.selectColor = row.rgb2 || "#ffffff";
      this.customerPaperwork.unSelectBgColor = row.rgb3 || "#ffffff";
      this.customerPaperwork.unSelectColor = configJson.rgb4 || "#ffffff";
      this.customerPaperwork.btnColor = configJson.rgb5 || "#ffffff";
      this.customerPaperwork.navOpacity = +configJson.navOpacity || 100;
      this.resetRgb(row, configJson);
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        const configJson = this.templateObj.configJson
          ? JSON.parse(this.templateObj.configJson)
          : {};
        this.templateId = this.templateId;
        this.resetRgb(this.templateObj, configJson);
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
      }
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.getDetail();
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //生成规则
    generateRule() {
      let text1 = `参与方式：用户报名参与（消费者需要手动报名，未报名不统计），报名时间：${this.ruleDTO.participateTimeStart} ~${this.ruleDTO.participateTimeEnd}；`,
        text2 = `开榜时间：${this.ruleDTO.rankPrizeTime}；`,
        text3 = "参与规则：完成任务集分数，按累计分数数排行；",
        text4 =
          "若出现分数相同的情况，将按照时间的先后顺序进行排名；排行榜类活动会出现5-10分钟延迟，请稍后进入活动查看相关信息；",
        text5 = "活动奖品：\n",
        text6 =
          "活动领奖限制：整个活动期内获奖用户只可领取对应中奖名次中的1个奖品，需在开榜后且活动结束前进入活动页面确认领取奖品;",
        text7 =
          "如果是实物奖项，需填写收货地址后进行发货，且仅有一次填写地址机会，活动结束后不允许填写地址，请在活动时间内填写地址，否则将视为放弃机会；",
        text8 =
          "因平台订单接口限流，部分订单可能有所延迟，订单状态会持续更新，请耐心等待稍后再试；",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【活动奖品】",
        fourthText = "\n四、【注意事项】";
      let conditionText = "";
      this.taskDataList.forEach((item, index) => {
        conditionText += `（${index + 1}）${useCondition(
          item,
          this,
          this.isShowCustom,
          "",
          this.mainText
        )}`;
        if (index < this.taskDataList.length - 1) {
          conditionText += "\n";
        }
      });
      if (this.taskDataList.length > 0) {
        text3 += "\n" + conditionText;
      }
      this.prizeSetting.forEach((item, index) => {
        text5 += `（${index + 1}）第${
          item.scoreRankWinConditionDTO.winType == 0
            ? item.scoreRankWinConditionDTO.rankStart +
              "~" +
              item.scoreRankWinConditionDTO.rankEnd +
              "名"
            : item.scoreRankWinConditionDTO.rankNum + "名"
        }，可领取${item.title}，共${item.totalAmount ? item.totalAmount : 1}份${
          item.prizeType == 3 ? "，单份奖品价值" + item.price + "元" : ""
        }；${index != this.prizeSetting.length - 1 ? "\n" : ""}`;
      });
      if (this.ruleDTO.participateType == 1) {
        text1 =
          "参与方式：活动期间内进入活动时自动判断用户身份，符合条件则自动报名；";
      }
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember
      );
      let Arr1 = [
        firstText,
        [secondText, text1, text2, text3, text4],
        [thirdText, text5, text6, text7, text8],
        [fourthText, precautions],
      ];
      let newText = "";
      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },

    // 下一步
    resetForm() {
      // 公共校验
      if (!useValidateBasicInformation(this)) {
        return;
      }
      if (this.ruleDTO.participateType == 0) {
        if (
          !this.ruleDTO.participateTimeStart &&
          !this.ruleDTO.participateTimeEnd
        ) {
          return this.$message.warning("请选择报名时间");
        }
      }
      if (this.taskDataList.length == 0) {
        return this.$message.warning("请新增任务");
      }
      if (!this.ruleDTO.rankPrizeTime) {
        return this.$message.warning("请选择开榜时间");
      }
      // 校验购买商品下单结束时间需早于开榜时间30分钟~
      if (this.ruleDTO.rankPrizeTime) {
        const obj = this.taskDataList.find((item) => item.type == 17);
        if (obj) {
          const orderEndTime = this.compareTime(obj.orderEndTime);
          const rankPrizeTime = this.compareTime(this.ruleDTO.rankPrizeTime);
          if (orderEndTime > rankPrizeTime - 30 * 60 * 1000) {
            return this.$message.warning("下单结束时间需早于开榜时间30分钟~");
          }
        }
      }
      if (
        this.ruleDTO.participateTimeStart &&
        this.ruleDTO.participateTimeEnd
      ) {
        //报名时间需在报名时间范围内
        if (
          this.compareTime(this.ruleDTO.participateTimeStart) >
          this.compareTime(this.ruleDTO.participateTimeEnd)
        ) {
          return this.$message.warning("报名开始时间不可晚于结束时间");
        }
      }
      if (
        this.ruleDTO.rankPrizeTime &&
        this.compareTime(this.ruleDTO.participateTimeEnd) >
          this.compareTime(this.ruleDTO.rankPrizeTime)
      ) {
        return this.$message.warning("报名结束时间需在开榜时间之前");
      }
      // 开榜时间需在活动时间范围内，且在活动结束时间24小时及之前
      if (this.ruleDTO.rankPrizeTime) {
        const rankPrizeTime = this.compareTime(this.ruleDTO.rankPrizeTime);
        const actStartTime = this.compareTime(this.ruleForm.startTime);
        const actEndTime = this.compareTime(this.ruleForm.endTime);
        // 开榜时间必须晚于等于活动开始时间
        if (rankPrizeTime < actStartTime) {
          return this.$message.warning("开榜时间需在活动时间范围内");
        }
        // 开榜时间必须早于等于活动结束时间前24小时
        const oneDay = 24 * 60 * 60 * 1000;
        if (rankPrizeTime > actEndTime - oneDay) {
          return this.$message.warning("开榜时间需在活动结束时间24小时及之前");
        }
      }
      const isConditon = this.prizeSetting.some((item) => {
        if (item.scoreRankWinConditionDTO.winType == 0) {
          return (
            !item.scoreRankWinConditionDTO.rankStart ||
            !item.scoreRankWinConditionDTO.rankEnd
          );
        }
        if (item.scoreRankWinConditionDTO.winType == 1) {
          return !item.scoreRankWinConditionDTO.rankNum;
        }
      });
      if (!useValidatePrizeInformation(this, "prizeSetting")) {
        return;
      }
      if (isConditon) {
        return this.$message.warning("请完善排名设置");
      }

      for (let i = 0; i < this.prizeSetting.length; i++) {
        const item = this.prizeSetting[i];
        const condition = item.scoreRankWinConditionDTO;

        if (condition.winType === 0) {
          const start = Number(condition.rankStart);
          const end = Number(condition.rankEnd);
          if (end <= start) {
            return this.$message.warning("区间结束值必须大于开始值");
          }
        }

        if (i > 0) {
          const prevItem = this.prizeSetting[i - 1];
          const prevCondition = prevItem.scoreRankWinConditionDTO;
          const prevEnd =
            prevCondition.winType === 0
              ? Number(prevCondition.rankEnd)
              : Number(prevCondition.rankNum);
          const currStart =
            condition.winType === 0
              ? Number(condition.rankStart)
              : Number(condition.rankNum);

          if (currStart <= prevEnd) {
            return this.$message.warning("排名设置需从上至下依次递增");
          }
        }
      }

      if (!useValidateActEndInfomation(this)) {
        return;
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      // 奖品必选
      if (this.prizeSetting.some((item) => !item.prizeType)) {
        this.$message.warning("请至少选择一个奖品");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      const obj = useInputBasicInformation(this,81);
      // 奖品处理
      let prizeListCommon = JSON.parse(JSON.stringify(this.prizeSetting));
      prizeListCommon = prizeListCommon.filter((item) => item.prizeType);
      obj.pointActivityPrizeDTOList = prizeListCommon;
      // 任务
      if (this.taskDataList.length) {
        obj.taskList = useInputTaskData(this.taskDataList);
      } else {
        obj.taskList = [];
      }
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          const params = useUpdateBasicInformation(obj, prizeListCommon, this);
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
            // 草稿箱保存正式活动删除id
            if (!obj.status) {
              delete obj.id;
            }
          }
          saveOrUpdateScoreRank(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        getScoreRankDetail(this.valueRow.id)
          .then((res) => {
            const { pointActivityPrizeDTOList, taskList } = res.data;
            useOutputBasicInformation(res.data, this);
            if (!this.activityData.isCopy) {
              // 奖品回显
              this.prizeSetting =
                pointActivityPrizeDTOList &&
                pointActivityPrizeDTOList.length > 0
                  ? pointActivityPrizeDTOList
                  : [
                      {
                        assetsId: null, // 资产项id(计划id优惠卷id商品id)
                        prizeType: null,
                        price: null,
                        logo: null,
                        title: "",
                        totalAmount: null,
                        singleAmount: "",
                        scoreRankWinConditionDTO: {
                          winType: 0, //排名类型
                          rankStart: "", //排名开始
                          rankEnd: "", //排名结束
                          rankNum: "", //指定名次
                        },
                      },
                    ];
            }
            // 任务回显
            if (taskList.length > 0) {
              this.taskDataList = useOutputTaskData(taskList, this);
            }
            this.getPolite();
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .showTip {
    color: red;
    font-size: 14px;
  }
  .openTip {
    margin-left: 8px;
    color: #333333;
  }
  .rule_box {
    background-color: #f7f8fa;
    padding: 16px 16px 1px;
    border-radius: 4px;
    font-size: 14px;
  }
  .upload-box {
    width: 450px;
    padding: 20px 20px 1px;
    background: #f4f6fa;
    border-radius: 4px;
  }
}

.ml8 {
  margin-left: 8px;
}

.mlr8 {
  margin: 0 8px;
}

.ml16 {
  margin-left: 16px;
}

.w100 {
  width: 100px;
}
.w80 {
  width: 80px;
}
.w200 {
  width: 200px;
}
.w60 {
  width: 60px;
}

.flex-c {
  display: flex;
  flex-direction: column;
}
.flex-r {
  display: flex;
  align-items: center;
}
/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}
</style>
